module.exports = {
  "下载":"下载",
  "打开":"打开",
    language: {
      name: '简体中文',
      title: '选择语言',
      subList: [
        {
          name: 'English',
          link: 'en',
        },
        // {
        //   name: '简体中文',
        //   link: 'zh',
        // },
        {
            name: '繁體中文',
            link: 'tw',
        },
        {
          name: '日本語',
          link: 'jp',
        },
        {
          name: '한국어',
          link: 'kr',
        },
        {
          name: 'ไทย',
          link: 'th',
        },
        {
          name: 'Tiếng Việt',
          link: 'vn',
        },
        {
          name: 'Español',
          link: 'es',
        },
      ]
    },
    "user":{//我的
      "wdtd": "我的团队",
      "wdyj": "我的业绩",
      "ren": "人",
    },
    "kjsy":{
      "title": "收益",
      "fxsy": "分享收益",
      "zjlsl": "总奖励数量：",
      "jl": "奖励",
      "sj": "日期",
      "sl": "数量",
      "sm": "说明"
    },
    "pay":{//购买
      "title": '购买矿机',
      "gmsl": '购买数量',
      "zf": '支付',
      "kyye": '可用余额',
      "kyyebz": '可用余额不足',
      "bztbtips": '输入的提币数量小于该币种最低提币要求',
      "bztbtips2": '提币数量不能低于最低提币',
      "qsrjymm": '请输入6位交易密码',
      "wxts": '温馨提示',
    },
    "chongbi":{
      "title": '充币',
      "lianmc": '链类型',
      "scl": '生成专属链',
      "sy": '私钥',
      "ewm": '二维码',
      "bcewm": '保存二维码',
      "cbdz": '充币地址',
      "fz": '复制',
      "sl": '充币数量',
      "qsrsl": '请输入充币数量',
      "sjczje": '实际充值金额',
      "qsrsjczje": '请输入实际充值金额',
      "pzms": '凭证描述',
      "qsrms": '请输入描述',
      "hxz": '哈希值',
      "qsrhxz": '请输入哈希值',
      "pztp": '凭证图片',
      "qscpztp": '请上传凭证图片',
      "fzcg": '复制成功',
      "yhkcz": '银行卡充值',
      "usdtcz": 'USDT充值',
      "btccz": 'BTC充值',
      "xzbz": '选择币种',
      "sure": '确认',
      "ck": '查看',
      "tips1": "请勿向上述地址充值任何非本币种资产否则资产不可找回",
      "tips2": "1.您发送网络和目标平台是一致的；如您选择了目标地址是以太坊网络，发送时必须选择相对应智能链，如有误您将无法找回您的数字资产。 ",
      "tips3": "2.发送前确保您的地址，网络一致。",
      "tips4": "温馨提示：由于区块网络匿名和私密，一旦输入错误信息，您将损失对应资产。请务必仔细核对您的发送地址。",
    },
    "usdttb":{
      "title": '提币',
      "lmc": '链类型',
      "xzl": '选择链',
      "xztbdz": '选择提币地址',
      "qsrtbdz": '请输入提币地址',
      "tbdz": '提币地址',
      "qsrdz": '请输入地址',
      "tbsl": '提币数量',
      "tbsl2": '提币数量：',
      "qsrtbsl": '请输入提币数量',
      "sjtxje": '实际提现金额',
      "qsrsjtxje": '请输入实际提现金额',
      "dzje":'到账金额',
      "jymm": '交易密码',
      "qsrjymm": '请输入交易密码',
      "sxf": '手续费',
      "qsrsxf": '请输入手续费',
      "dzsl": '到账数量',
      "dzsl2": '到账数量：',
      "qsrdzsl": '请输入到账数量',
      "wxts": '温馨提示：',
      "mrzdtxcs": '每次最低提币数量：',
      "hxxf": '还需消费',
      "cktx": '才可提现',
      "ci": '次',
      "wddtxyq": '未达到提现要求',
      "tjcg": '提交成功，请等待审核',
      "tips": '自身算力需大于1T（体验矿机算力除外）或者伞下算力大于50T方可提币。',
      "dz": '地址',
      "qd": '确定',
      "zdtb": "最低提币"
    },
    "kefu":{
      "title":'联系客服',
      "zxkf":'联系客服',
      "fzcg":'复制成功'
    },
    "xgdlmm":{//修改登录密码
      "title":'修改登录密码',
      "t1":'当前登录密码',
      "t2":'请输入当前登录密码',
      "t3":'新密码',
      "t4":'请输入6-16位数字和字母',
      "t5":'确认密码',
      "t6":'请输入6-16位数字和字母',
      "t7":'确认',
      "t8":'密码跟确认密码不一致',
      "mm":"密码",
      "qsrmm":"请输入密码",
      "qqrmm":"请确认密码",
      "qsrsjh":"请输入手机号",
      "zc":"注册",
      "mmts":"密码长度6-12位",
    },
    "sztxmm":{//设置提现密码
      "title":'修改交易密码',
      "wjtkmm": '忘记交易密码',
      "qsrjdlmm":'请输入当前交易密码',
      "zh": '账号',
      "qsryxhzsj": '请输入邮箱或者手机',
      "t1":'当前交易密码',
      "t2":'新交易密码',
      "t3":'请输入6位交易密码',
      "t4":'确认密码',
      "t5":'忘记交易密码？',
      "t6":'确认',
      "t7":'密码跟确认密码不一致',
      "t8":'交易密码',
      "yzm": '验证码',
      "qsryzm": '请输入验证码',
      "hqyzm": '获取验证码'
    },
    "record": {
      "cbjl": '充币记录',
      "tbjl": '提币记录',
      "status":"['未审核','已通过','已驳回']",
      "bhly": '驳回理由',
      "ldz": '地址：',
      "cjsj": '创建时间：',
      "zzsj": '转账时间：',
      "czl": '充值链：',
      "zrl": '转入链：',
      "jyhx": '交易哈希：'
    },
    "yqm": {
      "wdyqlj": '我的邀请链接',
      "wdyqm": '我的邀请码',
      "schbyq": '生成海报邀请',
      "bctp": '保存图片',
      "qx": '取消',
      "fx": '分享',
      "yqm": '复制邀请码',
      "bcewmdxc": '保存二维码到相册',
      "bcbd": '保存本地'
    },
    "wdtd": {
      "title": '我的团队',
      "td": '的团队',
      "yqhy": '邀请好友',
      "ren": '人',
      "wdtdzrs": '我的团队总人数',
      "uid": 'UID：',
      "zh": '账号：',
      "tdrs": '团队人数：',
      "zcsj": '注册日期：'
    },
    "wdyj": {
      "title": '我的业绩',
      "wdyd": '我的一代',
      "dyj": '的业绩',
      "tdzyj": '团队总业绩',
      "uid": 'UID：',
      "tdrs": '团队人数：',
      "yj": '业绩：'
    },
    "zc": {
      "title": '资产',
      "zzczh": '总资产折合',
      "dh": '兑换',
      "yczc": '隐藏为0的资产',
      "xj": '现价',
      "zh": '折合 ',
      "zcmx": '资产明细',
    },
    "duihuang": {
      "title": '兑换',
      "hl": '汇率',
      "zf": '支付',
      "qbdh": '全部兑换',
      "ky": '可用',
      "dd": '得到',
      "ljdh": '立即兑换',
      "cont": '汇率变动，以实际到账数额为准',
      "yebz": '余额不足',
      "ksslbz": '可卖数量不足',
      "qtxje": '请输入数量',
      "dhcg": '兑换成功',
      "mrcg": '买入成功',
      "mccg": '卖出成功',
      "wtcg": '委托成功',
      "ts": '提示',
      "btcmTips": '根据智能合约设定，GDCC兑换USDT将于2023年8月8日启动。',
      "qx": '取消'
    },
    "sign":{
      "title": '签到领币',
      "title2": '每日签到奖励',
      "title3": '签到奖励',
      "qd": '签到',
      "yqd": '已签到',
      "hdgz": '活动规则',
      "qdjl": '签到记录',
      "qdcg": '签到成功'
    },
    "langNew": {
      "wd": "我的",
      "jd": "借贷",
      "jghy": "期货",
      "xbsg": "新币申购",
      "sylx": "收益类型",
      "syts": "收益天数：",
      "rsy": "日收益：",
      "rsy2": "日收益",
      "yjdts": "已借贷天数：",
      "jdsy": "借贷收益：",
      "jdsy2": "借贷收益",
      "jdrq": "借贷日期：",
      "qdsy": "签到收益",
      "tgsy": "推广收益",
      "sybl": "收益比例",
      "sybl2": "收益比例：",
      "ljcy": "立即参与",
      "zsy": "总收益",
      "jdrz": "节点认证",
      "jiedian": "节点",
      "qsrje": "请输入节点",
      "xyb": "下一步",
      "zhye": "账户余额",
      "dzye": "地址余额",
      "zhyezh": "账户余额(折合)",
      "zq": "周期：",
      "zq2": "周期",
      "jdsl": "借贷数量",
      "yxbd": "邮箱绑定",
      "qsryxzh": "请输入邮箱账号",
      "yxgz": "输入的邮箱不符合规则",
      "jxz": "进行中",
      "ywc": "已完成",
      "day": "天",
      "jg": "价格：",
      "zwsj": "暂无数据~",
      "wyjb": "我要借币",
      "fxjl": "分享奖励",
      "aqsz": "安全设置",
      "wded": "我的二代",
      "wdsd": "我的三代",
      "dbxe": "单笔限额",
      "tjdd": "提交订单",
      "tqsh": "提取赎回：",
      "shuhui": "赎回",
      "ljdz": "链接地址",
      "yyqh": "语言切换",
      "zxkf": "在线客服",
      "syl": "收益率",
      "zhuanbi": "赚币",
      "zbsy": "赚币收益",
      "mc": "名称",
      "zxj": "最新价",
      "zfb": "涨幅榜",
      "shouye": "首页",
      "gg": "公告",
      "rzz": "认证中",
      "yrz": "已认证",
      "rzsb": "认证不通过，请重新认证",
      "cxrz": "重新认证",
      "jymmts": "请设置交易密码"
    },
    "xbsg":{
      "title": "新币申购",
      "wdsg": "我的申购",
      "scts": "锁仓天数：",
      "sy": "剩余",
      "ljsg": "立即申购",
      "ysk": "已售空",
      "xzjdy": "现在就订阅",
      "dy": "订阅",
      "fxjg": "发行价格",
      "fxl": "发行量",
      "ssrq": "上市日期",
      "yxqx": "有效期限",
      "qsrsl": "请输入数量",
      "syl": "剩余量",
      "sgrq": "申购日期",
      "sgsl": "申购数量",
      "bz": "币种",
      "yebz": "USDT余额不足",
      "tgsl": "通过数量",
      "shz": "审核中",
      "wtg": "未通过",
      "ytg": "已通过"
    },
    "wydb":{
      "title": "我要贷币",
      "db": "贷币",
      "dbz": "贷币中",
      "jl": "记录",
      "jdzq": "借贷周期(天)",
      "qhk": "去还款",
      "ljdb": "累计贷币(usdt)",
      "dhkbs" :"待还款笔数",
      "jkje": "借款金额(usdt)",
      "qsrje": "请输入金额",
      "rll": "日利率",
      "hkfs": "还款方式",
      "dqych": "到期一次还本息",
      "lx": "利息",
      "fkjg": "放款机构",
      "tpsc": "信用贷款(图片上传)",
      "fwxx": "房屋信息",
      "srzm": "收入证明(雇佣关系)",
      "yhmx": "银行明细",
      "zjz": "证件照",
      "yd": "本人已阅读并同意",
      "xy": "申请贷币协议",
      "sqdb": "点击申请贷币",
      "gb": "关闭",
      "qd": "确定",
      "ts": "请勾选申请贷币协议",
      "dbjl": "贷币记录",
      "hkhth": "贷款合同号",
      "wsh": "未审核",
      "yfk": "已放款",
      "sqrq": "申请日期",
      "zq": "周期",
      "dbsl": "贷币数量",
      "zhke": "总还款额",
      "yhkxq": "应还款详情",
      "bqyhk": "本期应还款（USDT）",
      "hktips": "请确保余额充足，余额不足请先充值再还款",
      "bj": "本金",
      "jie": "借",
      "ljhk": "立即还款",
      "qcz": "去充值",
      "yebzqxcz": "余额不足，请先充值再还款",
      "znj": "滞纳金",
      "yqts": "逾期天数"
    },
    "hkxq":{
      "dd":"订单",
      "fzhkdz":"复制还款地址",
      "hkxq": "还款详情",
      "zlx": "总利息",
      "zhk": "总还款",
      "hkjg": "还款机构",
      "qschkpz": "请上传还款凭证",
      "hkpz": "还款凭证"
    },
    "kxt":{
      "gao":"高",
      "di":"低",
      "wtgd":"委托挂单",
      "cj":"成交",
      "jj":"简介",
      "sj":"时间",
      "fx":"方向",
      "jg":"价格",
      "sl":"数量",
      "mr":"买入",
      "mc":"卖出",
      "mp":"买盘",
      "sp":"卖盘",
      "slb":"数量",
      "fhsj":"发行时间",
      "fhsl":"发行数量",
      "bps":"白皮书",
      "gw":"官网",
      "fz":"min",
      "xs":"hour",
      "tian":"day",
      "zhou":"week",
      "yue":"月",
      "gd":"more",
      "ft":"副图",
      "zt":"主图",
      "sdt":"深度图",
      "zx":"自选",
      "djck": "点击查看"
    },
    "jghy":{
      "jghy": "期权合约",
      "yxhy": "永续合约",
      "mz": "买涨",
      "md": "买跌",
      "gmj": "购买价",
      "jsj": "结算价",
      "xj": "现价",
      "fx": "方向",
      "sl": "数量",
      "jgsj": "交割时间",
      "gb": "关闭",
      "jxxd": "继续下单",
      "cclb": "持仓列表",
      "zc": "在持",
      "lscc": "历史持仓",
      "qblx": "全部类型",
      "yk": "盈亏",
      "ddqr": "订单确认",
      "dqsj": "到期时间",
      "jssj": "结算时间",
      "sy": "收益",
      "tzje": "投资金额",
      "zdje": "投资金额大于0",
      "kyye": "可用余额",
      "kyye2": "可用余额：",
      "sxf": "手续费：",
      "sxfl": "手续费",
      "jypz": "名称",
      "jyfx": "交易方向",
      "qrxd": "确认下单",
      "fs": "more",
      "dqye": "当前余额"
    },
    "zhjl":{
      "title": "账户记录",
      "cbtb":"充币提币",
      "jymx":"交易明细",
      "tgyj":"推广佣金",
      "wwc": "未完成",
      "ywc": "已完成"
    },
    "assets":{
      "total":"资产折合(USD)",
      "avaiable":"可用",
      "conversion":"折合",
      "canuse":"可用",
      "yczc":"隐藏为0的资产"
    },
    "tipsNew":{
      "wjmmts": "通过验证码找回密码",
      "qscpztp": "请上传凭证图片",
      "emailgsts": "输入的邮箱不符合规则",
      "telgsts": "输入的手机号码格式有误",
      "lcmmbyz": "两次密码输入不一致",
      "zdsl": "最低数量 ",
      "sldydy": "数量大于等于",
      "zxtzsl": "最低数量 ",
      "ddz": "等待中",
      "xs": "小时",
      "min": "最小数量 ",
      "max": "最大数量 ",
      "yebz": "余额不足",
      "qsrss": "请输入手数",
      "zdss": "最低手数",
      "yjj": "已拒绝",
      "shz": "赎回中",
      "zwkfcz": "该币种暂未开放充值",
      "jiaoge": "交割",
      "zhang": "涨",
      "die": "跌",
    },
    "status":{
      "statusText": ['失败','等待处理','成功'],
    },
    "langNew2":{
      "zczgz": "总资产",
      "hgx": "合规性",
      "yszc": "隐私政策",
      "gywm": "关于我们",
      "zb": "AI 套利",
      "mnjy": "模拟交易",
      "xbzq": "新币专区",
      "flzq": "福利专区",
      "cjmnzhcg": "创建模拟账户成功！",
      "wdzh": "我的账户",
      "yymnzhts": "已有虚拟账户,请勿重复注册",
      "tcmnzh": "退出模拟账号",
      "mnzhgz": "模拟账户估值",
      "mnzh": "模拟账户",
      "ljdzsb": "连接地址失败",
      "ysq": "已授权"
    },
    "c2c":{
      "bt": "C2C",
      "bt2": "C2C买币",
      "cjdd": "创建订单",
      "mblc": "买币流程",
      "cjydd": "创建预订单",
      "xmjfk": "向卖家付款",
      "tqhb": "提取您的数字货币",
      "ddzt": "订单状态",
      "wdys": "我们的优势",
      "c1": "低廉的交易费用",
      "c2": "在我们的C2C买币上,下单方以零手续费交易,我承诺在所有市场用最低的C2C交易费用",
      "c3": "多种支付方式",
      "c4": "点对点(C2C)交易允许卖家自由定义透明想要的付款方式,通过700多种支付方式,买卖加密货币包括银行转账,现金。",
      "c5": "以您喜欢的价格交易",
      "c6": "以您喜欢的价格自由买卖加密货币,从现有报价中买卖,或创建交易广告来设置您理想的价格",
      "wpp": "未匹配",
      "ypp": "已匹配",
      "ysx": "已失效",
      "ddh": "订单号",
      "mrje": "买入金额",
      "mrbz": "买入币种",
      "nssdgj": "国家",
      "qsrnssdgj": "请输入国家",
      "fkrxm": "存款人姓名",
      "qsrfkrxm": "请输入存款人姓名",
      "yx": "邮箱",
      "qsryx": "请输入邮箱",
      "mmbz": "购买类型",
      "qxzmmbz": "请选择购买类型",
      "qxz": "请选择",
      "fkfs": "付款方式",
      "qtxfkfs": "请填写付款方式",
      "zh": "账户",
      "fb": "支付货币类型",
      "qtxfb": "请填写支付货币类型",
      "ngmdje": "您购买的金额",
      "qsrje": "请输入金额",
      "wxts": "温馨提示：",
      "dsh": "待审核",
      "ygq": "已过期",
      "jcwdwt": "C2C简介",
      "tjpz": "提交凭证",
      "ckje": "匹配金额",
      "qsrckje": "请输入匹配金额",
      "tjzzfb": "转账副本",
      "tjjzzm": "驾照正面",
      "tjjzfm": "驾照反面",
      "psts1": "拍摄时注意以下几点",
      "psts2": "请注意图片的边框完整,字体清晰,亮度均匀",
      "psts3": "请勿上传与姓名不符的证件照",
      "qsczzfb": "请上传转账副本",
      "qscjzzm": "请上传驾照正面",
      "qscjzfm": "请上传驾照反面",
      "tj": "提交",
      "je": "金额",
      "ljtg": "立即托管",
      "sp": "了解DEFI",
      "xq": "详情",
      "lxkfppdd": "联系客服匹配订单",
      "szgj": "所在国家",
      "qsrszgj": "请输入所在国家",
      "fkyhmc": "付款银行名称",
      "qsrfkyhmc": "请输入付款银行名称",
      "dianhui": "电汇/国际电汇",
      "ccsr": "此处输入"
    },
    "xyf":{
      "title": "信用分",
      "pgsj": "评估时间"
    },
    "bbjy":{
      "mr":"买入",
      "mc":"卖出",
      "mai":"买",
      "sell":"卖",
      "xj":"限价",
      "sj":"市价",
      "pk":"盘口",
      "jg":"价格",
      "sl":"数量",
      "mrl":"买入量",
      "ss":"数量",
      "mcl":"卖出量",
      "ky":"可用",
      "km":"可买",
      "ksell":"可卖",
      "jye":"交易额",
      "dqwt":"当前委托",
      "lswt":"历史委托",
      "jj":"简介",
      "wtzl":"委托总量",
      "wtjg":"委托价格",
      "ycjl":"已成交量",
      "cjjj":"成交均价",
      "cd":"撤单",
      "xd":"下单",
      "ywc":"已完成",
      "ycd":"已撤单",
      "wqcj":"完全成交",
      "zx":"自选",
      "scjg":"市场价格",
      "fhsj":"发行时间",
      "fhsl":"发行数量",
      "bps":"白皮书",
      "gw":"官网",
      "qx":"取消",
      "bbjy": "币币交易"
    },
    "hyjy":{
      "mai":"买",
      "sell":"卖",
      "kc":"开仓",
      "pc":"平仓",
      "cc":"持仓",
      "kp":"可平",
      "kpc":"可平空",
      "kcc":"可持仓",
      "kkd":"可开多",
      "kpd":"可平多",
      "kkk":"可开空",
      "xj":"限价",
      "sj":"市价",
      "xjwt":"限价委托",
      "sjwt":"市价委托",
      "pk":"盘口",
      "jg":"价格",
      "sl":"数量",
      "gg":"杠杆",
      "tzgg":"调整杠杆",
      "ggbs": "杠杆倍数",
      "mrl":"买入量",
      "ky":"可用",
      "jye":"交易额",
      "dqwt":"当前委托",
      "lswt":"历史委托",
      "ptwt":"普通委托",
      "dqwtmr":"当前委托(买入)",
      "dqwtmc":"当前委托(卖出)",
      "hywt":"合约委托",
      "jj":"简介",
      "wtzl":"委托总量",
      "wtjg":"委托价格",
      "ycjl":"已成交量",
      "cjjj":"成交均价",
      "cd":"撤单",
      "xd":"下单",
      "qbcd":"全部撤单",
      "wqcj":"完全成交",
      "ywc":"已完成",
      "ycd":"已撤单",
      "zx":"自选",
      "scjg":"市场价格",
      "fhsj":"发行时间",
      "fhsl":"发行数量",
      "bps":"白皮书",
      "gw":"官网",
      "mrzd":"买入做多",
      "mrpk":"买入平空",
      "mczk":"卖出做空",
      "mcpd":"卖出平多",
      "mrkdkz":"买入开多(看涨)",
      "mrpkkz":"买入平空(看涨)",
      "mckkkd":"卖出开空(看跌)",
      "mcpdkd":"卖出平多(看跌)",
      "yxhy":"永续合约",
      "dc":"多仓",
      "kcjj":"开仓均价(BUSDT)",
      "wsxyl":"未实现盈利(BUSDT)",
      "ygqpj":"预估强评价(BUSDT)",
      "syl":"收益率",
      "cwbzj":"仓位保证金(BUSDT)",
      "cw":"仓位(张)",
      "cwjz":"仓位价值(BUSDT)",
      "bzjl":"保证金率",
      "kpz":"可平(张)",
      "bdzs":"标的指数",
      "tzbzj":"调整保证金",
      "zyzs":"止盈止损",
      "zjbzj":"增加保证金",
      "jsbzj":"减少保证金",
      "tyhy":"体验合约",
      "ccz":"持仓(张)",
      "cwbzjt":"仓位保证金(TBTC)",
      "zdzjbzj":"最多增加保证金(TBTC)",
      "zjbzjt":"增加保证金(TBTC)",
      "zhang":"数量",
      "qblx":"全部类型",
      "qb":"全部",
      "ccjg":"持仓价格",
      "ccsl":"持仓数量",
      "yk":"盈亏",
      "ccsj":"持仓时间",
      "zy":"止盈",
      "zs":"止损",
      "zje":"总金额",
      "kcs":"开仓数",
      "kcjg":"开仓价格",
      "ss":"手数",
      "hand":"1手 =",
      "qx":"取消",
      "qr":"确认"
    },
    "bbjyNew":{
      "jylx": "交易类型",
      "jyze": "交易总额"
    },
    "langNew3":{
      "bzxq": "搬砖详情",
      "znbz": "AI量化智能搬砖",
      "apits": "无缝对接全球200+交易所Api",
      "jr": "加入",
      "gn": "功能",
      "lhjs": "AI量化介绍",
      "jqrts": "机器人是如何工作的？",
      "sctj": "市场统计",
      "scqk": "市场情况",
      "jiaoge": "交割",
      "zhang": "涨",
      "die": "跌",
      "sz": "设置",
      "qbcp": "全部产品",
      "jrlh": "加入AI量化",
      "sywd": "0风险,收益稳定",
      "bzbz": "搬砖币种"
    },
    "sztkmm":{
      "title":"设置交易密码",
      "dlmm":"登录密码",
      "dlmmts":"请输入登录密码",
      "xmm":"新密码",
      "mmts":"密码长度6位数字",
      "qrmm":"确认密码",
      "qr":"确认",
      "qd": "确定",
      "sztkts": "提示：请到安全中心设置交易密码"
    },
    "bzhl":{
      "title":"派息",
      "gz":"规则",
      "tgdd":"托管订单",
      "zztgdzj":"正在托管的资金",
      "yjjrsy":"预估日收益",
      "ljsy":"总收入",
      "tgzdd":"托管中订单",
      "cljxcp":"策略竞选产品",
      "dbxe":"单笔限额",
      "rsyl":"日收益率",
      "zq":"周期",
      "qmr":"立即购买",
      "bbzhzc": "账户资产",
      "zcc": "总持仓(USDT)",
      "dd":"订单",
      "buy":"买入",
      "jxcp":"精选产品",
      "ckdd":"查看订单",
      "gd":"更多",
      "xzbzts": "简单，安全。可选择多种币种进行派息",
      "qtbz": "其它币种",
      "dj": "级",
      "cjwt": "常见问题",
      "ddsl": "订单数量",
      "sl": "数量"
    },
    "bzhlgm":{
      "title":"搬砖获利",
      "bzhld":"搬砖获利得usdt",
      "qtzq":"USDT7天周期",
      "rsyl":"日收益率(%)",
      "lczq":"理财周期",
      "dbxe":"单笔限额 ",
      "pxsj":"派息时间",
      "mr":"每日",
      "dqfh":"到期返还",
      "tgzj":"托管资金",
      "tqsh":"提取赎回",
      "yjsy":"预计收益(USDT)",
      "kyzc":"可用资产(USDT)",
      "cpjs":"产品介绍",
      "tgje":"托管金额",
      "qsrtgje":"请输入托管金额",
      "qb":"全部",
      "rm":"点击这里",
      "cpzq":"产品周期",
      "jxr":"计息日",
      "jiexr":"结息日",
      "yjdzr":"预计到账日",
      "gz":"了解规则以及权益"
    },
    "bzhlwdtg":{
      "title":"订单状态",
      "tgz":"托管中",
      "ywc":"已完成",
      "ysh":"已赎回",
      "tgje":"托管金额/周期天数",
      "rsyl":"日收益率",
      "yhl":"已获利/剩余天数",
      "xdsj":"下单时间",
      "sh":"赎回",
      "ddxq":"订单详情",
      "ddh":"订单号",
      "syts": "剩余天数",
      "ddztxq": "订单状态详情"
    },
    "langNew4":{
      "kp": "开盘",
      "zuoshou": "昨收",
      "zg": "最高",
      "zd": "最低",
      "dqjg": "当前价格",
      "pcjg": "平仓价格",
      "gd": "挂单",
      "gdj": "挂单价",
      "gdjg": "挂单价格",
      "xfbzj": "需付保证金：",
      "ksrfw": "可输入范围：",
      "shou": "手",
      "fdjyk": "浮动净盈亏",
      "pcsl": "平仓数量",
      "cx": "撤销",
      "qrpc": "确认平仓",
      "sx": "筛选",
      "cz": "重置",
      "zdl": "知道了",
      "kccg": "开仓成功！",
      "xzfx": "选择方向",
      "lx": "类型",
      "xgcc": "修改持仓",
      "szzyzs": "设置止盈止损",
      "szhb": "数字货币",
      "gjs": "贵金属",
      "yy": "原油",
      "jy": "交易",
      "jmhb": "加密货币",
      "gdsj": "挂单时间",
      "gdsl": "挂单数量",
      "fs": "time"
     },
     "deals":{
      "issue_time":"发行时间",
      "issue_number": "发行数量",
      "white_book": "白皮书",
      "weburl": "官网",
      "video_url": "视频介绍",
      "introduction":"简介",
      "onhand":"1手等于",
      "position": "当前持仓",
      "leverorder":"杠杆下单",
      "leverposition":"杠杆持仓",
      "inputprice":"输入价格",
      "inputmul":"输入倍数",
      "selectmul":"选择倍数",
      "onehand":"1手等于",
      "hand":"交易手数",
      "marketval":"合约市值",
      "bond":"保证金",
      "service":"服务费",
      "balance":"余额",
      "type":"类型",
      "risk":"风险率",
      "total":"持仓总盈亏：",
      "onekey":"一键平仓",
      "makemore":"(做多)",
      "makeless":"(做空)",
      "current":"当前委托",
      "all":"全部",
      "weing":"委托中",
      "tding":"交易中",
      "ping":"平仓中",
      "pied":"已平仓",
      "ceiled":"已撤单",
      "weprice":"委托价",
      "oprice":"开仓价",
      "nowprice":"当前价",
      "zyprice":"止盈价",
      "zsprice":"止损价",
      "canbond":"可用保证金",
      "optime":"开仓时间",
      "pgtime":"平仓时间",
      "znum":"折合数量",
      "gprice":"隔夜费",
      "pcang":"平仓",
      "revoke":"撤单",
      "fee":"手续费",
      "you":"以当前最优价格交易"
    },
    "zyzs":{
      "title":"止盈止损",
      "zy":"止盈",
      "zs":"止损",
      "qsrzyjg":"请输入止盈价格",
      "qsrzsjg":"请输入止损价格",
      "cfjglx":"触发价格类型：",
      "zsjg":"指数价格",
      "scjg":"市场价格",
      "pcfs":"平仓方式：",
      "kpcw":"可平仓位",
      "qbcw":"全部仓位",
      "wxts":"温馨提示：",
      "cont": "市场平仓，可能会因为行情波动剧烈等问题导致一定概率市价单下单失败，无法成功止盈止损。",
      "qr":"确认",
    },
    "level1": {
      "name": "真实姓名",
      "idcard": "证件类型：",
      "address": "现住地址",
      "bank_number": "银行卡号",
      "wc": "确定",
      "name_nodata": "姓名不能为空",
      "id_card_nodata": "证件号码不能为空",
      "address_nodata": "地址不能为空",
      "bank_number_nodata": "银行卡号不能为空",
      "input-username":"请输入真实姓名",
      "zjhm":"证件号码",
      "input-idcard":"请输入证件号码",
      "input-address":"请输入地址",
      "zjlx":"证件类型",
      "qxzzjlx":"请选择证件类型",
      "sfz":"身份证",
      "hz":"护照",
      "jsz":"驾驶证",
      "lxz":"留学证",
      "zfbzh": "支付宝账号",
      "qsrzfbzh": "请输入支付宝账号",
      "khh": "开户行",
      "qsrkhh": "请输入开户行",
      "yhkh": "银行卡号",
      "qsryhkh": "请输入银行卡号",
      "zfzh": "支付账户",
      "qxzzfzh": "请选择支付账户",
      "gjlb": "国家列表",
      "qxzgjlb": "请选择国家/地区",
      "gjhdq": "国家/地区",
      "qtxgj": "请填写国家/地区"
    },
    "gjrz":{
      "title":"实名认证",
      "t1":"1、支持小于8M的JPG、JPEG或PNG格式图片。",
      "t2":"2、证件照要求清晰，不允许任何修改和遮挡，必须看清人像，证件号和姓名。",
      "t3":"3、照片需免冠，建议未化妆，手持证件人的五官清晰可鉴，完整需露出手臂。",
      "t4":"确定",
      "bh":"驳回",
      "shz":"审核中",
      "shtg":"审核通过",
      "nyrzcg":"您已认证成功",
      "sczjz":"上传证件照",
      "sczjzmz": "上传证件正面照",
      "sczjbmz": "上传证件背面照",
      "scgrqmz": "上传手持证件照",
      "wdtjr": "我的推荐人",
      "tjrid": "推荐人ID",
      "qsrtjrid": "请输入推荐人ID",
      "idbcz": "推荐人ID 不存在",
      "tjcg": "提交成功",
      "tjridts": "推荐人ID 不能填自己",
      "qsrzh": "请输入账号",
      "dl": "登录",
      "jc": "较差",
      "yb": "一般",
      "yx": "优秀",
      "ldjsqh": "伦敦金属期货",
      "wh": "外汇",
    },
    "newReg":{
      "sjh":"手机号",
      "yx":"邮箱",
      "yqm":"邀请码",
      "yqm2":"邀请码（可选）",
      "cjzh":"创建账户",
      "sysjhzyx":"使用手机号/电子邮箱注册",
      "sj":"手机",
      "yhxy":"《用户协议》",
      "yhxy2":"我已阅读并同意《用户协议》",
      "hmyzh":"还没有账号？",
      "qzc":"去注册",
      "qbdl":"钱包登录",
      "qyqbfw":"请用钱包APP访问",
      "dc":"登出"
    },
}



// WEBPACK FOOTER //
// ./src/utils/lang/zh.js